import { useEffect, useState } from "react";
import ButtonIcon from "@components/buttonIcon/ButtonIcon";
import "./CardContato.scss";
import { useForm } from "react-hook-form";
import UtilServices from "@services/UtilServices";
import Input from "@components/input/Input";
import DropDownList from "@components/dropDownList/DropDownList";
import MessageServices from "@services/MessageServices";
import usePermissoes from "@hooks/usePermissoes";

export default function CardContato(props) {
  const [editar, setEditar] = useState(false);
  const [criarNoCard, setCriarNoCard] = useState([]);
  const { handlePermissoes } = usePermissoes();

  //Contato
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    reset,
  } = useForm();

  // Resetar o formulário quando a lista de contatos mudar
  useEffect(() => {
    if (props.lstContatoFilter.length > 0 && !editar) {
      setCriarNoCard([]);
      reset();
      setDropDownValue([]); //DropDown
    }
  }, [props.lstContatoFilter]);

  function validarContatos(dados) {
    const temContato = Object.keys(dados).some((key) => {
      return (
        (key.startsWith("telefoneNew") || key.startsWith("emailNew")) &&
        dados[key] &&
        dados[key].trim() !== ""
      );
    });

    return temContato;
  }
  async function handleEditarCard(data) {
    //Se for criar.
    if (props.criar) {
      //Validações anteriores
      if (data.contatopessoa === "CNPJ" && !props?.CNPJ) {
        MessageServices.ShowWarning(
          "Nenhum CNPJ foi selecionado para adicionar um novo contato!",
        );
        return;
      }
      if (data.contatopessoa === "Socio" && !props?.ID_Empresa_Socio) {
        MessageServices.ShowWarning(
          "Nenhum sócio foi selecionado para adicionar um novo contato!",
        );
        return;
      }

      if (!validarContatos(data)) {
        MessageServices.ShowWarning(
          "É necessário informar pelo menos um telefone ou e-mail.",
        );
        return;
      }

      props.setlstContato((contatosAnteriores) => {
        // Cria um novo contato
        const telefonesNovos = Object.keys(data)
          .filter((key) => key.startsWith("telefoneNew") && data[key]) // Filtra valores não vazios
          .map((key) => ({
            id: UtilServices.generateUUID(),
            valor: data[key].replace(/\D/g, ""), // Remove tudo que não for número
            prioridade: "0",
            tipocontato: "Comercial",
            idContato: null,
          }));

        const emailsNovos = Object.keys(data)
          .filter((key) => key.startsWith("emailNew") && data[key]) // Filtra valores não vazios
          .map((key) => ({
            id: UtilServices.generateUUID(),
            valor: data[key],
            prioridade: "1",
            tipocontato: "Comercial",
            idContato: null,
          }));

        const novoContato = {
          nome: data.nomesobrenome,
          idCard: UtilServices.generateUUID(),
          contatopessoa: data.contatopessoa,
          Telefone: telefonesNovos,
          Email: emailsNovos,
        };

        // Adiciona o novo card à lista de contatos e remove o criado.
        const lstAlterada = [
          ...contatosAnteriores.filter((item) => item.criar !== true),
          novoContato,
        ];

        // Atualiza o estado
        props.setlstContatoFilter(lstAlterada);
        props.handleEditar(lstAlterada);
        return lstAlterada;
      });

      return;
    }

    props.setlstContato((contatosAnteriores) => {
      const lstAlterada = contatosAnteriores.map((contato) => {
        // Verifica se o idcard é o mesmo.
        if (contato.idCard === props.idCard) {
          //Atualiza o nome
          contato.nome = data?.nomesobrenome;

          // Atualiza os telefones, se o id existir
          const atualizaTelefones = contato.Telefone?.map((telefone) => {
            const idTelefone = `telefone ${telefone.id}`;
            if (data[idTelefone]) {
              return { ...telefone, valor: data[idTelefone] };
            }
            return telefone;
          });

          // Adiciona novos telefones se não existirem e se o valor não for vazio
          const telefonesNovos = Object.keys(data)
            .filter((key) => key.startsWith("telefoneNew") && data[key]) // Filtra valores não vazios
            .map((key, index) => ({
              id: UtilServices.generateUUID(),
              valor: data[key].replace(/\D/g, ""), // Remove tudo que não for número,
              prioridade: "0",
              tipocontato: "Comercial",
              edit: "1",
              idContato: null,
            }));

          // Atualiza os e-mails, se o id existir
          const AtualizaEmails = contato.Email?.map((email) => {
            const idEmail = `email ${email.id}`;
            if (data[idEmail]) {
              return { ...email, valor: data[idEmail] };
            }
            return email;
          });

          // Adiciona novos e-mails se não existirem e se o valor não for vazio
          const emailsNovos = Object.keys(data)
            .filter((key) => key.startsWith("emailNew") && data[key]) // Filtra valores não vazios
            .map((key, index) => ({
              id: UtilServices.generateUUID(),
              valor: data[key],
              prioridade: "1",
              tipocontato: "Comercial",
              edit: "1",
              idContato: null,
            }));

          return {
            ...contato,
            Telefone: [...atualizaTelefones, ...telefonesNovos],
            Email: [...AtualizaEmails, ...emailsNovos],
          };
        }
        return contato;
      });

      // Retorna a lista alterada para atualizar o estado
      props.setlstContatoFilter(lstAlterada);
      props.handleEditar(lstAlterada);
      return lstAlterada;
    });
  }
  function handleExcluirCard() {
    //Excluir o criado.
    if (props.criar) {
      props.setlstContatoFilter((prevState) =>
        prevState.filter((item) => item.criar !== true),
      );
      props.setlstContato((prevState) =>
        prevState.filter((item) => item.criar !== true),
      );
      return;
    }
    //Excluir o card já existente.
    props.setlstContato((prevState) => {
      const lstAlterada = prevState.filter(
        (item) => item.idCard !== props.idCard,
      );
      props.setlstContatoFilter(lstAlterada);
      props.handleEditar(lstAlterada);
      return lstAlterada;
    });
  }
  function handleMap() {
    props.telefone.forEach((item, index) => {
      setValue(`telefone ${item.id}`, item?.valor);
    });
    props.email.forEach((item, index) => {
      setValue(`email ${item.id}`, item?.valor);
    });
    setValue("nomesobrenome", props.nome || "");
  }
  const [dropDownValue, setDropDownValue] = useState();
  function handleChangeDropDownLst(name, value, valueAdicionar) {
    setValue(name, value);
    setDropDownValue(valueAdicionar);
  }

  return (
    <div
      className={`cardcontato ${props.background ? "card2" : ""}`}
      style={{ background: props.background }}
    >
      <form onSubmit={handleSubmit(handleEditarCard)}>
        {/* Botões dos card */}
        <div className="cardcontato-botoes">
          <ButtonIcon
            Excluir
            titleExcluir={"Excluir Card"}
            onExcluir={() => {
              handleExcluirCard();
            }}
            disabledExcluir={!handlePermissoes(2, "Contato", "Inativar")}
            typeExcluir={"button"}
          />
          <div className="cardcontato-salvar-editar">
            {(editar || props.criar) && (
              <ButtonIcon
                Salvar
                titleSalvar={"Salvar"}
                disabledSalvar={!handlePermissoes(2, "Contato", "Editar")}
                typeSalvar={"submit"}
              />
            )}
            <ButtonIcon
              Editar
              titleEditar={"Editar"}
              onEditar={() => {
                setEditar(!editar);
                handleMap();
                if (editar) {
                  setCriarNoCard([]);
                  props.setlstContatoFilter(props.lstContato);
                }
              }}
              disabledEditar={
                //se as permissões forem false ou criar for true então ele disabilita.
                handlePermissoes(2, "Contato", "Editar") === false ||
                props.criar === true
                  ? true
                  : false
              }
              typeEditar={"button"}
            />
          </div>
        </div>
        {/* Informações do card */}
        {/* input do nome e o tipo de card */}
        <div className="cardcontato-a">
          <p className="cardcontato-contatopessoa">
            {props?.contatopessoa === "CNPJ" ? (
              <i class="fa-solid fa-users"></i>
            ) : (
              <i class="fa-solid fa-handshake"></i>
            )}
            {UtilServices.primeiraLetraMaiuscula(
              props?.contatopessoa === "CNPJ"
                ? "Empresa"
                : props?.contatopessoa,
            )}
          </p>
          {editar === false && !props.criar ? (
            <p className="cardcontato-nome">
              {UtilServices.primeiraLetraMaiuscula(props.nome)}
            </p>
          ) : (
            <div className="cardcontato-input-dropdown">
              <Input
                className="cardcontato-input-nome"
                placeholder={"Nome"}
                setValue={setValue}
                register={register}
                errors={errors}
                type={"nomesobrenome"}
                registerProps={{
                  required: "O e-mail é obrigatório",
                }}
                name="nomesobrenome"
                theme="3"
              />
              {!editar && (
                <DropDownList
                  theme="4"
                  data={[
                    { id: 0, key: "Socio" },
                    { id: 1, key: "CNPJ" },
                  ]}
                  name="contatopessoa"
                  placeholder="Selecione"
                  required
                  onChange={handleChangeDropDownLst}
                  value={dropDownValue}
                  register={register}
                  errors={errors}
                  registerProps={{
                    required: "Campo obrigatório!",
                  }}
                />
              )}
            </div>
          )}
          {/* input de telefone */}
          <div className="cardcontato-input" style={{ marginBottom: "10px" }}>
            {props.telefone.map((telefone, index) =>
              editar === false && !props.criar ? (
                <div>
                  <i className="fa-solid fa-phone"></i>
                  <p>{UtilServices.maskPhone(telefone.valor)}</p>
                </div>
              ) : (
                <Input
                  placeholder={"DDD + Telefone"}
                  setValue={setValue}
                  register={register}
                  errors={errors}
                  type="phone"
                  // mask="telefone"
                  maxLength="18"
                  registerProps={{
                    validate: {
                      isValid: (value) =>
                        UtilServices.validatePhone(value) ||
                        "Telefone inválido",
                    },
                  }}
                  name={`telefone ${telefone.id}`}
                  theme="3"
                  //Button
                  button
                  iconButton={"Excluir"}
                  titleButton={"Excluir Campo"}
                  typeButton={"button"}
                  gapButton="5px"
                  onClickButton={() => {
                    props.setlstContatoFilter((prevContatos) =>
                      prevContatos.map((contato) => ({
                        ...contato,
                        Telefone: contato.Telefone.filter(
                          (item) => item.id !== telefone.id,
                        ),
                      })),
                    );
                    props.setlstContato((prevContatos) =>
                      prevContatos.map((contato) => ({
                        ...contato,
                        Telefone: contato.Telefone.filter(
                          (item) => item.id !== telefone.id,
                        ),
                      })),
                    );
                  }}
                />
              ),
            )}
          </div>
          {/* Input email */}
          <div className="cardcontato-input">
            {props.email.map((email, index) =>
              editar === false && !props.criar ? (
                <div>
                  <i className="fa-solid fa-envelope"></i>
                  <p>{email.valor}</p>
                </div>
              ) : (
                <Input
                  placeholder={"Email"}
                  setValue={setValue}
                  register={register}
                  errors={errors}
                  registerProps={{
                    validate: {
                      isValid: (value) =>
                        UtilServices.validateEmail(value) || "E-mail inválido",
                    },
                  }}
                  name={`email ${email.id}`}
                  theme="3"
                  //Button
                  button
                  iconButton={"Excluir"}
                  titleButton={"Excluir Campo"}
                  typeButton={"button"}
                  gapButton="5px"
                  onClickButton={() => {
                    props.setlstContatoFilter((prevContatos) =>
                      prevContatos.map((contato) => ({
                        ...contato,
                        Email: contato.Email.filter(
                          (item) => item.id !== email.id,
                        ),
                      })),
                    );
                    props.setlstContato((prevContatos) =>
                      prevContatos.map((contato) => ({
                        ...contato,
                        Email: contato.Email.filter(
                          (item) => item.id !== email.id,
                        ),
                      })),
                    );
                  }}
                />
              ),
            )}
          </div>
          {/* Novos campos input */}
          {criarNoCard.map((criar, index) => (
            <div
              style={{ marginTop: "15px" }}
              className="cardcontato-input-criar"
            >
              <p style={{ width: "100%", marginBottom: "5px" }}>
                Preencha um dos campos.
              </p>
              <Input
                placeholder={"DDD + Telefone"}
                setValue={setValue}
                register={register}
                errors={errors}
                type="phone"
                mask="telefone"
                maxLength="18"
                registerProps={{
                  validate: {
                    isValid: (value) =>
                      UtilServices.validatePhone(value) || "Telefone inválido",
                  },
                }}
                name={`telefoneNew${index}`}
                theme="3"
              />
              <Input
                placeholder={"Email"}
                setValue={setValue}
                register={register}
                errors={errors}
                registerProps={{
                  validate: {
                    isValid: (value) =>
                      UtilServices.validateEmail(value) || "E-mail inválido",
                  },
                }}
                name={`emailNew${index}`}
                theme="3"
              />
            </div>
          ))}
          {/* criar e deletar novos inputs */}
          <div className="cardcontato-button-criar">
            {(editar || props.criar) && (
              <ButtonIcon
                Criar
                titleCriar={"Adicionar mais campos"}
                onCriar={() => {
                  setCriarNoCard((prevState) => [
                    ...prevState,
                    { criar: prevState.criar ? prevState.criar + 1 : 1 },
                  ]);
                }}
                typeCriar={"button"}
              />
            )}
            {criarNoCard.length > 0 && (
              <ButtonIcon
                Excluir
                titleExcluir={"Fechar os campos extras e redefinir o card."}
                onExcluir={() => {
                  criarNoCard.forEach((_, index) => {
                    setValue(`telefoneNew${index}`, "");
                    setValue(`emailNew${index}`, "");
                  });
                  setCriarNoCard([]);

                  // reset();
                  // setDropDownValue([]);
                }}
                typeExcluir={"button"}
              />
            )}
          </div>
        </div>
      </form>
    </div>
  );
}

CardContato.defaultProps = {
  nome: "",
  telefone: [],
  email: [],
  criar: false,
};
